import type { SkuWaveFixture } from './sku-model'

// Read-only inputs extracted from Copy of D26 Hall Sku Wave Break - 2026.xlsm.
// Preserve source TTL QTY, including manual Replen quantities; wave percentages come from the overview.
const WORKBOOK_SKU_WAVE_FIXTURES: SkuWaveFixture[] = [
  {
    id: '7156',
    description: 'SWEET & SPOOKY (Magic & Mischief)',
    setDate: '2026-06-12',
    exitDate: '2026-09-25',
    pogDescription: 'Magical Mischief SC',
    location: 'SC - FMA 4',
    status: null,
    stores: 1416,
    dcCount: 7,
    sellableCount: 49,
    shippingCount: 48,
    piabCount: 6,
    cicoCount: 32,
    repackCount: 10,
    repackShipQty: 40616,
    lines: [
      {
        id: '7156:15',
        sourceRow: 15,
        sku: '10812622',
        description: 'ASH PLUSH SKELETON BOY',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.68,
        cost: 6.47,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 7560,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 7560,
        totalInnerPacks: 3780,
        avgStoreUnits: 5.338983050847458,
        workbookNote: null,
      },
      {
        id: '7156:16',
        sourceRow: 16,
        sku: '10812621',
        description: 'ASH PLUSH SKELETON GIRL',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.68,
        cost: 6.47,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 7560,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 7560,
        totalInnerPacks: 3780,
        avgStoreUnits: 5.338983050847458,
        workbookNote: null,
      },
      {
        id: '7156:17',
        sourceRow: 17,
        sku: '10812628',
        description: 'ASH PLW TRICK OR TREAT',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.351,
        cost: 3.41,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 3780,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3780,
        totalInnerPacks: 1890,
        avgStoreUnits: 2.669491525423729,
        workbookNote: null,
      },
      {
        id: '7156:18',
        sourceRow: 18,
        sku: '10812627',
        description: 'ASH PLW HOCUS POCUS ',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.351,
        cost: 3.41,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 3780,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3780,
        totalInnerPacks: 1890,
        avgStoreUnits: 2.669491525423729,
        workbookNote: null,
      },
      {
        id: '7156:19',
        sourceRow: 19,
        sku: '10812624',
        description: 'ASH SPOOKY JUICE DECOR',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.542,
        cost: 6.08,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 4536,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4536,
        totalInnerPacks: 2268,
        avgStoreUnits: 3.2033898305084745,
        workbookNote: null,
      },
      {
        id: '7156:20',
        sourceRow: 20,
        sku: '10812635',
        description: 'ASH TT SKULL HEAD COUNTDOWN',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 8,
        ip: 2,
        cube: 0.773,
        cost: 2.34,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 7888,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 7888,
        totalInnerPacks: 3944,
        avgStoreUnits: 5.570621468926554,
        workbookNote: null,
      },
      {
        id: '7156:21',
        sourceRow: 21,
        sku: '10812638',
        description: 'ASH TT SKELE TRICK OR TREAT',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 8,
        ip: 2,
        cube: 1.268,
        cost: 3.02,
        retail: 24.99,
        childPurchaseUnits: null,
        purchaseQty: 3784,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3784,
        totalInnerPacks: 1892,
        avgStoreUnits: 2.672316384180791,
        workbookNote: null,
      },
      {
        id: '7156:22',
        sourceRow: 22,
        sku: '10812639',
        description: 'ASH TT DISCO GHOST JUMBO LG',
        type: 'Single SKU',
        vendor: 'TEST RITE - PUTIAN HESHENG HANDICRAFT AR',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 4.796,
        cost: 32.2,
        retail: 149.99,
        childPurchaseUnits: null,
        purchaseQty: 7236,
        moq: 10000,
        pogSet: 1,
        pogMax: 2,
        totalQty: 7236,
        totalInnerPacks: 7236,
        avgStoreUnits: 5.110169491525424,
        workbookNote: '100% only 2-skus',
      },
      {
        id: '7156:23',
        sourceRow: 23,
        sku: '10812640',
        description: 'ASH TT DISCO GHOST JUMBO SM',
        type: 'Single SKU',
        vendor: 'TEST RITE - PUTIAN HESHENG HANDICRAFT AR',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 3.187,
        cost: 29,
        retail: 129.99,
        childPurchaseUnits: null,
        purchaseQty: 8100,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 8100,
        totalInnerPacks: 8100,
        avgStoreUnits: 5.720338983050848,
        workbookNote: '100% only 2-skus',
      },
      {
        id: '7156:24',
        sourceRow: 24,
        sku: '10812661',
        description: 'D-PIAB NEON SIGN CHILD',
        type: 'Parent',
        vendor: 'TEST RITE - TG BROTHER CHRISTMAS GIFT CO',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.664,
        cost: 27.5,
        retail: 119.96,
        childPurchaseUnits: null,
        purchaseQty: 2160,
        moq: 5000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 2160,
        totalInnerPacks: 2160,
        avgStoreUnits: 1.5254237288135593,
        workbookNote: null,
      },
      {
        id: '7156:25',
        sourceRow: 25,
        sku: '10812641',
        description: 'ASH BO NEON SIGN SKULL BOY',
        type: 'Child',
        vendor: 'TEST RITE - TG BROTHER CHRISTMAS GIFT CO',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.36,
        cost: 6.76,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 4320,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4320,
        totalInnerPacks: 2160,
        avgStoreUnits: 3.0508474576271185,
        workbookNote: null,
      },
      {
        id: '7156:26',
        sourceRow: 26,
        sku: '10812646',
        description: 'ASH BO NEON SIGN SKULL GIRL',
        type: 'Child',
        vendor: 'TEST RITE - TG BROTHER CHRISTMAS GIFT CO',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.36,
        cost: 6.99,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 4320,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4320,
        totalInnerPacks: 2160,
        avgStoreUnits: 3.0508474576271185,
        workbookNote: null,
      },
      {
        id: '7156:27',
        sourceRow: 27,
        sku: '10812678',
        description: 'D-PIAB ASH TT NUTCRACKER S6',
        type: 'Parent',
        vendor: 'TESTRITE BLOOMHOME INDUSTRIAL (THAILAND) CO., LTD.',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 1.123,
        cost: 29.04,
        retail: 179.88,
        childPurchaseUnits: null,
        purchaseQty: 1800,
        moq: 10000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1800,
        totalInnerPacks: 1800,
        avgStoreUnits: 1.271186440677966,
        workbookNote: null,
      },
      {
        id: '7156:28',
        sourceRow: 28,
        sku: '10812645',
        description: 'ASH TT NUTCRACKER 10" WITCH',
        type: 'Child',
        vendor: 'TESTRITE BLOOMHOME INDUSTRIAL (THAILAND) CO., LTD.',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 2.044,
        cost: 2.42,
        retail: 14.99,
        childPurchaseUnits: 5256,
        purchaseQty: 3600,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:29',
        sourceRow: 29,
        sku: '10812648',
        description: 'ASH TT NUTCRACKER 10" CAT',
        type: 'Child',
        vendor: 'TESTRITE BLOOMHOME INDUSTRIAL (THAILAND) CO., LTD.',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 2.044,
        cost: 2.42,
        retail: 14.99,
        childPurchaseUnits: 5040,
        purchaseQty: 3600,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:30',
        sourceRow: 30,
        sku: '10812650',
        description: 'ASH TT NUTCRACKER 10" PUMPKIN',
        type: 'Child',
        vendor: 'TESTRITE BLOOMHOME INDUSTRIAL (THAILAND) CO., LTD.',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 2.044,
        cost: 2.42,
        retail: 14.99,
        childPurchaseUnits: 5592,
        purchaseQty: 3600,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:31',
        sourceRow: 31,
        sku: '10812654',
        description: 'ASH TT NTCRK 10" SKLTN BOY',
        type: 'Child',
        vendor: 'TESTRITE BLOOMHOME INDUSTRIAL (THAILAND) CO., LTD.',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 2.044,
        cost: 2.42,
        retail: 14.99,
        childPurchaseUnits: 5040,
        purchaseQty: 3600,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:32',
        sourceRow: 32,
        sku: '10812656',
        description: 'ASH TT NTCRK 10" SKLTN GIRL',
        type: 'Child',
        vendor: 'TESTRITE BLOOMHOME INDUSTRIAL (THAILAND) CO., LTD.',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 2.044,
        cost: 2.42,
        retail: 14.99,
        childPurchaseUnits: 5040,
        purchaseQty: 3600,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:33',
        sourceRow: 33,
        sku: '10812657',
        description: 'ASH TT NUTCRACKER 10" FRANK',
        type: 'Child',
        vendor: 'TESTRITE BLOOMHOME INDUSTRIAL (THAILAND) CO., LTD.',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 2.044,
        cost: 2.42,
        retail: 14.99,
        childPurchaseUnits: 3432,
        purchaseQty: 3600,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:34',
        sourceRow: 34,
        sku: '10812644',
        description: 'ASH THROW PURPLE GHOST',
        type: 'Single SKU',
        vendor: 'TEST RITE - SHANGHAI SUNWIN INDUSTRY GRO',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.831,
        cost: 7.51,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 5400,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5400,
        totalInnerPacks: 2700,
        avgStoreUnits: 3.8135593220338984,
        workbookNote: '100% only 3-skus',
      },
      {
        id: '7156:35',
        sourceRow: 35,
        sku: '10812642',
        description: 'ASH THROW BLACK',
        type: 'Single SKU',
        vendor: 'TEST RITE - SHANGHAI SUNWIN INDUSTRY GRO',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.831,
        cost: 7.6,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 5400,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5400,
        totalInnerPacks: 2700,
        avgStoreUnits: 3.8135593220338984,
        workbookNote: '100% only 3-skus',
      },
      {
        id: '7156:36',
        sourceRow: 36,
        sku: '10812649',
        description: 'ASH THROW PINK AND MINT',
        type: 'Single SKU',
        vendor: 'TEST RITE - SHANGHAI SUNWIN INDUSTRY GRO',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.831,
        cost: 7.6,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 5400,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5400,
        totalInnerPacks: 2700,
        avgStoreUnits: 3.8135593220338984,
        workbookNote: '100% only 3-skus',
      },
      {
        id: '7156:37',
        sourceRow: 37,
        sku: '10812643',
        description: 'ASH HANGING ORN WREATH',
        type: 'Single SKU',
        vendor: 'UNIQUE TREASURES LTD',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 2.18,
        cost: 12,
        retail: 69.99,
        childPurchaseUnits: null,
        purchaseQty: 4752,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4752,
        totalInnerPacks: 2376,
        avgStoreUnits: 3.3559322033898304,
        workbookNote: '100% only 1-sku',
      },
      {
        id: '7156:38',
        sourceRow: 38,
        sku: '10812647',
        description: 'ASH PLW SKELETON COFFIN BLK',
        type: 'Single SKU',
        vendor: 'ALL COURTESY INTERNATIONAL LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 2.117,
        cost: 5.22,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 4860,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4860,
        totalInnerPacks: 2430,
        avgStoreUnits: 3.4322033898305087,
        workbookNote: '100% only 2-skus',
      },
      {
        id: '7156:39',
        sourceRow: 39,
        sku: '10812655',
        description: 'ASH PLW MOONLIGHT MISCHIEF',
        type: 'Single SKU',
        vendor: 'ALL COURTESY INTERNATIONAL LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.302,
        cost: 3.7,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 4536,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4536,
        totalInnerPacks: 2268,
        avgStoreUnits: 3.2033898305084745,
        workbookNote: '100% only 2-skus',
      },
      {
        id: '7156:40',
        sourceRow: 40,
        sku: '10812652',
        description: 'ASH WALL HLW ADVENT',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 6,
        ip: 2,
        cube: 0.89,
        cost: 7.05,
        retail: 49.99,
        childPurchaseUnits: null,
        purchaseQty: 3564,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3564,
        totalInnerPacks: 1782,
        avgStoreUnits: 2.516949152542373,
        workbookNote: null,
      },
      {
        id: '7156:41',
        sourceRow: 41,
        sku: '10812688',
        description: 'ASH PLW SKULL FLOWER BLU ORG',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.695,
        cost: 6.25,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 4320,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4320,
        totalInnerPacks: 2160,
        avgStoreUnits: 3.0508474576271185,
        workbookNote: null,
      },
      {
        id: '7156:42',
        sourceRow: 42,
        sku: '10812653',
        description: 'ASH PLW SKULL STAR PK WT YL PR',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.695,
        cost: 5.64,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 4320,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4320,
        totalInnerPacks: 2160,
        avgStoreUnits: 3.0508474576271185,
        workbookNote: null,
      },
      {
        id: '7156:43',
        sourceRow: 43,
        sku: '10812651',
        description: 'ASH PLW GHOST WHT',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.756,
        cost: 5.78,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 12960,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 12960,
        totalInnerPacks: 6480,
        avgStoreUnits: 9.152542372881356,
        workbookNote: null,
      },
      {
        id: '7156:44',
        sourceRow: 44,
        sku: '10812660',
        description: 'ASH TRAY HEART PINK',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 6,
        ip: 2,
        cube: 1.454,
        cost: 6.42,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 3780,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3780,
        totalInnerPacks: 1890,
        avgStoreUnits: 2.669491525423729,
        workbookNote: null,
      },
      {
        id: '7156:45',
        sourceRow: 45,
        sku: '10812679',
        description: 'D-PIAB ASH TT ROLLER THUMBS S2',
        type: 'Parent',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.914,
        cost: 12.8,
        retail: 87.96,
        childPurchaseUnits: null,
        purchaseQty: 1800,
        moq: 2000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1800,
        totalInnerPacks: 1800,
        avgStoreUnits: 1.271186440677966,
        workbookNote: null,
      },
      {
        id: '7156:46',
        sourceRow: 46,
        sku: '10812663',
        description: 'ASH TT CNTR ROLLER PINK',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.57,
        cost: 4.26,
        retail: 26.99,
        childPurchaseUnits: 1584,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:47',
        sourceRow: 47,
        sku: '10812664',
        description: 'ASH TT CER DÉCOR THUMBS A2',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.31,
        cost: 2.14,
        retail: 16.99,
        childPurchaseUnits: 2880,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:48',
        sourceRow: 48,
        sku: '10812659',
        description: 'ASH TT RESIN DÉCOR BLU CAMERA',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.24,
        cost: 3.17,
        retail: 22.99,
        childPurchaseUnits: null,
        purchaseQty: 4860,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4860,
        totalInnerPacks: 2430,
        avgStoreUnits: 3.4322033898305087,
        workbookNote: null,
      },
      {
        id: '7156:49',
        sourceRow: 49,
        sku: '10812667',
        description: 'ASH TT RESIN POPSICLE A2',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.381,
        cost: 2.21,
        retail: 16.99,
        childPurchaseUnits: null,
        purchaseQty: 5400,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5400,
        totalInnerPacks: 2700,
        avgStoreUnits: 3.8135593220338984,
        workbookNote: null,
      },
      {
        id: '7156:50',
        sourceRow: 50,
        sku: '10812680',
        description: 'D-PIAB ASH TT CER SHOE PEAC S2',
        type: 'Parent',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.608,
        cost: 11.66,
        retail: 67.96,
        childPurchaseUnits: null,
        purchaseQty: 1800,
        moq: 2000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1800,
        totalInnerPacks: 1800,
        avgStoreUnits: 1.271186440677966,
        workbookNote: null,
      },
      {
        id: '7156:51',
        sourceRow: 51,
        sku: '10812658',
        description: 'ASH TT CER SHOE CTNR A2',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.359,
        cost: 3.69,
        retail: 16.99,
        childPurchaseUnits: 1800,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:52',
        sourceRow: 52,
        sku: '10812662',
        description: 'ASH TT CER DÉC PEACE SIGN BLUE',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.37,
        cost: 2.14,
        retail: 16.99,
        childPurchaseUnits: 2124,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:53',
        sourceRow: 53,
        sku: '10812670',
        description: 'ASH TT RSIN DÉC TELEPHONE PINK',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.329,
        cost: 3.81,
        retail: 16.99,
        childPurchaseUnits: null,
        purchaseQty: 4860,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4860,
        totalInnerPacks: 2430,
        avgStoreUnits: 3.4322033898305087,
        workbookNote: null,
      },
      {
        id: '7156:54',
        sourceRow: 54,
        sku: '10812665',
        description: 'ASH TT RESIN SKULL W/BOW A3',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 3,
        ip: 3,
        cube: 0.822,
        cost: 3.94,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 6480,
        moq: 2000,
        pogSet: 3,
        pogMax: 6,
        totalQty: 6480,
        totalInnerPacks: 2160,
        avgStoreUnits: 4.576271186440678,
        workbookNote: null,
      },
      {
        id: '7156:55',
        sourceRow: 55,
        sku: '10812676',
        description: 'ASH TT PAPERMAC JOL CANDYBOWL',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.759,
        cost: 6.32,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 3564,
        moq: 4000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3564,
        totalInnerPacks: 1782,
        avgStoreUnits: 2.516949152542373,
        workbookNote: null,
      },
      {
        id: '7156:56',
        sourceRow: 56,
        sku: '10812683',
        description: 'D-PIAB ASH TT PAPERMACH JOL S2',
        type: 'Parent',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 2.153,
        cost: 25.28,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 1890,
        moq: 4000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1890,
        totalInnerPacks: 1890,
        avgStoreUnits: 1.3347457627118644,
        workbookNote: null,
      },
      {
        id: '7156:57',
        sourceRow: 57,
        sku: '10812673',
        description: 'ASH TT PAPERMACHE JOL W/O NOSE',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.077,
        cost: 6.32,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3780,
        moq: 4000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3780,
        totalInnerPacks: 1890,
        avgStoreUnits: 2.669491525423729,
        workbookNote: null,
      },
      {
        id: '7156:58',
        sourceRow: 58,
        sku: '10812677',
        description: 'ASH TT PAPERMACHE JOL W/ NOSE',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.077,
        cost: 6.32,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3780,
        moq: 4000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3780,
        totalInnerPacks: 1890,
        avgStoreUnits: 2.669491525423729,
        workbookNote: null,
      },
      {
        id: '7156:59',
        sourceRow: 59,
        sku: '10812684',
        description: 'D-PIAB ASH TT COFFIN SHELF S3',
        type: 'Parent',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 4.011,
        cost: 55.68,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 2160,
        moq: 2000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 2160,
        totalInnerPacks: 2160,
        avgStoreUnits: 1.5254237288135593,
        workbookNote: null,
      },
      {
        id: '7156:60',
        sourceRow: 60,
        sku: '10812669',
        description: 'ASH TT COFFIN SHELF BLUE',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.337,
        cost: 9.28,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 4320,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4320,
        totalInnerPacks: 2160,
        avgStoreUnits: 3.0508474576271185,
        workbookNote: null,
      },
      {
        id: '7156:61',
        sourceRow: 61,
        sku: '10812671',
        description: 'ASH TT COFFIN SHELF PINK',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.337,
        cost: 9.28,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 4320,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4320,
        totalInnerPacks: 2160,
        avgStoreUnits: 3.0508474576271185,
        workbookNote: null,
      },
      {
        id: '7156:62',
        sourceRow: 62,
        sku: '10812674',
        description: 'ASH TT COFFIN SHELF BLK',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.337,
        cost: 9.28,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 4320,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4320,
        totalInnerPacks: 2160,
        avgStoreUnits: 3.0508474576271185,
        workbookNote: null,
      },
      {
        id: '7156:63',
        sourceRow: 63,
        sku: '10812687',
        description: 'ASH ANI PLUSH ROLLER GHOST',
        type: 'Single SKU',
        vendor: 'GEMMY ENTERPRISE LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.906,
        cost: 13.7,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 8000,
        moq: 3000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 8000,
        totalInnerPacks: 4000,
        avgStoreUnits: 5.649717514124294,
        workbookNote: null,
      },
      {
        id: '7156:64',
        sourceRow: 64,
        sku: '10812682',
        description: 'ASH ANI  PLUSH ROLLER SKELETON',
        type: 'Single SKU',
        vendor: 'GEMMY ENTERPRISE LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.906,
        cost: 13.7,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 8000,
        moq: 3000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 8000,
        totalInnerPacks: 4000,
        avgStoreUnits: 5.649717514124294,
        workbookNote: null,
      },
      {
        id: '7156:65',
        sourceRow: 65,
        sku: '10812666',
        description: 'ASH ANI  PLUSH MUMMY DANCER',
        type: 'Single SKU',
        vendor: 'GEMMY ENTERPRISE LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.545,
        cost: 9.85,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 8000,
        moq: 3000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 8000,
        totalInnerPacks: 4000,
        avgStoreUnits: 5.649717514124294,
        workbookNote: null,
      },
      {
        id: '7156:66',
        sourceRow: 66,
        sku: '10812675',
        description: 'ASH ANI  PLUSH BOP JOL GIRL',
        type: 'Single SKU',
        vendor: 'GEMMY ENTERPRISE LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.483,
        cost: 10.5,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 8000,
        moq: 3000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 8000,
        totalInnerPacks: 4000,
        avgStoreUnits: 5.649717514124294,
        workbookNote: null,
      },
      {
        id: '7156:67',
        sourceRow: 67,
        sku: '10812672',
        description: 'ASH ANI  PLUSH DOG IN COSTUME',
        type: 'Single SKU',
        vendor: 'GEMMY ENTERPRISE LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.492,
        cost: 9.35,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 8000,
        moq: 3000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 8000,
        totalInnerPacks: 4000,
        avgStoreUnits: 5.649717514124294,
        workbookNote: null,
      },
      {
        id: '7156:68',
        sourceRow: 68,
        sku: '10812681',
        description: 'ASH ANI  PLUSH CORGI W/HAT',
        type: 'Single SKU',
        vendor: 'GEMMY ENTERPRISE LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.492,
        cost: 9.35,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 8000,
        moq: 3000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 8000,
        totalInnerPacks: 4000,
        avgStoreUnits: 5.649717514124294,
        workbookNote: null,
      },
      {
        id: '7156:69',
        sourceRow: 69,
        sku: '10812668',
        description: 'ASH ANI PLUSH SPLITS SKELETON',
        type: 'Single SKU',
        vendor: 'GEMMY ENTERPRISE LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.523,
        cost: 10,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 8640,
        moq: 3000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 8640,
        totalInnerPacks: 4320,
        avgStoreUnits: 6.101694915254237,
        workbookNote: null,
      },
      {
        id: '7156:71',
        sourceRow: 71,
        sku: '10812645',
        description: 'ASH TT NUTCRACKER 10" WITCH',
        type: 'Replen',
        vendor: 'TESTRITE BLOOMHOME INDUSTRIAL (THAILAND) CO., LTD.',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 2.044,
        cost: 2.42,
        retail: 14.99,
        childPurchaseUnits: 5256,
        purchaseQty: 3600,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:72',
        sourceRow: 72,
        sku: '10812648',
        description: 'ASH TT NUTCRACKER 10" CAT',
        type: 'Replen',
        vendor: 'TESTRITE BLOOMHOME INDUSTRIAL (THAILAND) CO., LTD.',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 2.044,
        cost: 2.42,
        retail: 14.99,
        childPurchaseUnits: 5040,
        purchaseQty: 3600,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:73',
        sourceRow: 73,
        sku: '10812650',
        description: 'ASH TT NUTCRACKER 10" PUMPKIN',
        type: 'Replen',
        vendor: 'TESTRITE BLOOMHOME INDUSTRIAL (THAILAND) CO., LTD.',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 2.044,
        cost: 2.42,
        retail: 14.99,
        childPurchaseUnits: 5592,
        purchaseQty: 3600,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:74',
        sourceRow: 74,
        sku: '10812654',
        description: 'ASH TT NTCRK 10" SKLTN BOY',
        type: 'Replen',
        vendor: 'TESTRITE BLOOMHOME INDUSTRIAL (THAILAND) CO., LTD.',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 2.044,
        cost: 2.42,
        retail: 14.99,
        childPurchaseUnits: 5040,
        purchaseQty: 3600,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:75',
        sourceRow: 75,
        sku: '10812656',
        description: 'ASH TT NTCRK 10" SKLTN GIRL',
        type: 'Replen',
        vendor: 'TESTRITE BLOOMHOME INDUSTRIAL (THAILAND) CO., LTD.',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 2.044,
        cost: 2.42,
        retail: 14.99,
        childPurchaseUnits: 5040,
        purchaseQty: 3600,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:76',
        sourceRow: 76,
        sku: '10812657',
        description: 'ASH TT NUTCRACKER 10" FRANK',
        type: 'Replen',
        vendor: 'TESTRITE BLOOMHOME INDUSTRIAL (THAILAND) CO., LTD.',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 2.044,
        cost: 2.42,
        retail: 14.99,
        childPurchaseUnits: 3432,
        purchaseQty: 3600,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:77',
        sourceRow: 77,
        sku: '10812663',
        description: 'ASH TT CNTR ROLLER PINK',
        type: 'Replen',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.57,
        cost: 4.26,
        retail: 26.99,
        childPurchaseUnits: 1584,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:78',
        sourceRow: 78,
        sku: '10812664',
        description: 'ASH TT CER DÉCOR THUMBS A2',
        type: 'Replen',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.31,
        cost: 2.14,
        retail: 16.99,
        childPurchaseUnits: 2880,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:79',
        sourceRow: 79,
        sku: '10812658',
        description: 'ASH TT CER SHOE CTNR A2',
        type: 'Replen',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.359,
        cost: 3.69,
        retail: 16.99,
        childPurchaseUnits: 1800,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '7156:80',
        sourceRow: 80,
        sku: '10812662',
        description: 'ASH TT CER DÉC PEACE SIGN BLUE',
        type: 'Replen',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.37,
        cost: 2.14,
        retail: 16.99,
        childPurchaseUnits: 2124,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
    ],
  },
  {
    id: '5695',
    description: 'DEAD REGENCY (Hallowed Halls)',
    setDate: '2026-07-17',
    exitDate: '2026-09-25',
    pogDescription: 'Hallowed Halls SC',
    location: 'SC - FMA 5',
    status: null,
    stores: 1416,
    dcCount: 7,
    sellableCount: 99,
    shippingCount: 78,
    piabCount: 13,
    cicoCount: 48,
    repackCount: 17,
    repackShipQty: 95952,
    lines: [
      {
        id: '5695:15',
        sourceRow: 15,
        sku: '10814859',
        description: 'ASH TT METAL CANDELABRA',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 2.682,
        cost: 6.91,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3500,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3500,
        totalInnerPacks: 1750,
        avgStoreUnits: 2.4717514124293785,
        workbookNote: null,
      },
      {
        id: '5695:16',
        sourceRow: 16,
        sku: '10814862',
        description: 'ASH TT GLS TIFFANY LAMP',
        type: 'Single SKU',
        vendor: 'TEST RITE WING ART LIGHTING AND GIFTWARE',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.998,
        cost: 20.3,
        retail: 49.99,
        childPurchaseUnits: null,
        purchaseQty: 5000,
        moq: 5000,
        pogSet: 1,
        pogMax: 2,
        totalQty: 5000,
        totalInnerPacks: 5000,
        avgStoreUnits: 3.531073446327684,
        workbookNote: null,
      },
      {
        id: '5695:17',
        sourceRow: 17,
        sku: '10814874',
        description: 'ASH TT GLASS LAMP W/ FRINGE',
        type: 'Single SKU',
        vendor: 'TEST RITE WING ART LIGHTING AND GIFTWARE',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.992,
        cost: 9.3,
        retail: 49.99,
        childPurchaseUnits: null,
        purchaseQty: 3300,
        moq: 5000,
        pogSet: 1,
        pogMax: 2,
        totalQty: 3300,
        totalInnerPacks: 3300,
        avgStoreUnits: 2.330508474576271,
        workbookNote: null,
      },
      {
        id: '5695:18',
        sourceRow: 18,
        sku: '10814884',
        description: 'D-PIAB ASH CND ROSE TAPER S3',
        type: 'Parent',
        vendor: 'TEST RITE - ZEST CANDLE LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.447,
        cost: 17.4,
        retail: 89.94,
        childPurchaseUnits: null,
        purchaseQty: 1500,
        moq: 5000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1500,
        totalInnerPacks: 1500,
        avgStoreUnits: 1.0593220338983051,
        workbookNote: null,
      },
      {
        id: '5695:19',
        sourceRow: 19,
        sku: '10814866',
        description: 'ASH CND ROSE TAPER GREY',
        type: 'Child',
        vendor: 'TEST RITE - ZEST CANDLE LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.149,
        cost: 2.9,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 3000,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3000,
        totalInnerPacks: 1500,
        avgStoreUnits: 2.1186440677966103,
        workbookNote: null,
      },
      {
        id: '5695:20',
        sourceRow: 20,
        sku: '10814870',
        description: 'ASH CND ROSE TAPER  BLK',
        type: 'Child',
        vendor: 'TEST RITE - ZEST CANDLE LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.149,
        cost: 2.9,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 3000,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3000,
        totalInnerPacks: 1500,
        avgStoreUnits: 2.1186440677966103,
        workbookNote: null,
      },
      {
        id: '5695:21',
        sourceRow: 21,
        sku: '10814872',
        description: 'ASH CND ROSE TAPER  GRN',
        type: 'Child',
        vendor: 'TEST RITE - ZEST CANDLE LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.149,
        cost: 2.9,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 3000,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3000,
        totalInnerPacks: 1500,
        avgStoreUnits: 2.1186440677966103,
        workbookNote: null,
      },
      {
        id: '5695:22',
        sourceRow: 22,
        sku: '10815574',
        description: 'D-PIAB ASH GLS CNDL HLDR S/2',
        type: 'Parent',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.265,
        cost: 3,
        retail: 59.96,
        childPurchaseUnits: null,
        purchaseQty: 1750,
        moq: 10000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1750,
        totalInnerPacks: 1750,
        avgStoreUnits: 1.2358757062146892,
        workbookNote: null,
      },
      {
        id: '5695:23',
        sourceRow: 23,
        sku: '10815550',
        description: 'ASH GLS CNDL HLDR BLACK',
        type: 'Child',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.132,
        cost: 0.75,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 3500,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3500,
        totalInnerPacks: 1750,
        avgStoreUnits: 2.4717514124293785,
        workbookNote: null,
      },
      {
        id: '5695:24',
        sourceRow: 24,
        sku: '10815553',
        description: 'ASH GLS CNDL HLDR GREEN',
        type: 'Child',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.132,
        cost: 0.75,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 3500,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3500,
        totalInnerPacks: 1750,
        avgStoreUnits: 2.4717514124293785,
        workbookNote: null,
      },
      {
        id: '5695:25',
        sourceRow: 25,
        sku: '10814886',
        description: 'D-PIAB ASH GLS BTL W/LID S/3',
        type: 'Parent',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.288,
        cost: 5.1,
        retail: 59.94,
        childPurchaseUnits: null,
        purchaseQty: 1900,
        moq: 10000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1900,
        totalInnerPacks: 1900,
        avgStoreUnits: 1.3418079096045197,
        workbookNote: null,
      },
      {
        id: '5695:26',
        sourceRow: 26,
        sku: '10814867',
        description: 'ASH GLS BTL SQUARE GREY',
        type: 'Child',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.096,
        cost: 0.85,
        retail: 9.99,
        childPurchaseUnits: null,
        purchaseQty: 3800,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3800,
        totalInnerPacks: 1900,
        avgStoreUnits: 2.6836158192090394,
        workbookNote: null,
      },
      {
        id: '5695:27',
        sourceRow: 27,
        sku: '10814869',
        description: 'ASH GLS BTL SQUARE BLACK',
        type: 'Child',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.096,
        cost: 0.85,
        retail: 9.99,
        childPurchaseUnits: null,
        purchaseQty: 3800,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3800,
        totalInnerPacks: 1900,
        avgStoreUnits: 2.6836158192090394,
        workbookNote: null,
      },
      {
        id: '5695:28',
        sourceRow: 28,
        sku: '10814873',
        description: 'ASH GLS BTL SQUARE GREEN',
        type: 'Child',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.096,
        cost: 0.85,
        retail: 9.99,
        childPurchaseUnits: null,
        purchaseQty: 3800,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3800,
        totalInnerPacks: 1900,
        avgStoreUnits: 2.6836158192090394,
        workbookNote: null,
      },
      {
        id: '5695:29',
        sourceRow: 29,
        sku: '10814885',
        description: 'D-PIAB ASH GLS BTL W/LID RD S3',
        type: 'Parent',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.348,
        cost: 5.1,
        retail: 59.94,
        childPurchaseUnits: null,
        purchaseQty: 1850,
        moq: 10000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1850,
        totalInnerPacks: 1850,
        avgStoreUnits: 1.3064971751412429,
        workbookNote: null,
      },
      {
        id: '5695:30',
        sourceRow: 30,
        sku: '10814865',
        description: 'ASH GLS BTL ROUND GREY',
        type: 'Child',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.116,
        cost: 0.85,
        retail: 9.99,
        childPurchaseUnits: null,
        purchaseQty: 3700,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3700,
        totalInnerPacks: 1850,
        avgStoreUnits: 2.6129943502824857,
        workbookNote: null,
      },
      {
        id: '5695:31',
        sourceRow: 31,
        sku: '10814868',
        description: 'ASH GLS BTL ROUND BLACK',
        type: 'Child',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.116,
        cost: 0.85,
        retail: 9.99,
        childPurchaseUnits: null,
        purchaseQty: 3700,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3700,
        totalInnerPacks: 1850,
        avgStoreUnits: 2.6129943502824857,
        workbookNote: null,
      },
      {
        id: '5695:32',
        sourceRow: 32,
        sku: '10814871',
        description: 'ASH GLS BTL ROUND GREEN',
        type: 'Child',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.116,
        cost: 0.85,
        retail: 9.99,
        childPurchaseUnits: null,
        purchaseQty: 3700,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3700,
        totalInnerPacks: 1850,
        avgStoreUnits: 2.6129943502824857,
        workbookNote: null,
      },
      {
        id: '5695:33',
        sourceRow: 33,
        sku: '10814676',
        description: 'ASH GLS COFFIN SHELF LG',
        type: 'Single SKU',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.159,
        cost: 5.7,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 5000,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5000,
        totalInnerPacks: 2500,
        avgStoreUnits: 3.531073446327684,
        workbookNote: null,
      },
      {
        id: '5695:34',
        sourceRow: 34,
        sku: '10814679',
        description: 'ASH GLS COFFIN SHELF SM',
        type: 'Single SKU',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.707,
        cost: 5.03,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 7000,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 7000,
        totalInnerPacks: 3500,
        avgStoreUnits: 4.943502824858757,
        workbookNote: null,
      },
      {
        id: '5695:35',
        sourceRow: 35,
        sku: '10816004',
        description: 'D-PIAB ASH CNTR GLS W/LID S/2',
        type: 'Parent',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 4,
        ip: 1,
        cube: 1.773,
        cost: 6,
        retail: 79.96,
        childPurchaseUnits: null,
        purchaseQty: 2500,
        moq: 10000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 2500,
        totalInnerPacks: 2500,
        avgStoreUnits: 1.765536723163842,
        workbookNote: null,
      },
      {
        id: '5695:36',
        sourceRow: 36,
        sku: '10815983',
        description: 'ASH CNTR GLS W/LID BLACK',
        type: 'Child',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.188,
        cost: 1.5,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 5000,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5000,
        totalInnerPacks: 2500,
        avgStoreUnits: 3.531073446327684,
        workbookNote: null,
      },
      {
        id: '5695:37',
        sourceRow: 37,
        sku: '10815984',
        description: 'ASH CNTR GLS W/LID GREEN',
        type: 'Child',
        vendor: 'TEST RITE - GOLDEN ACE INDUSTRIAL CO LTD',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.188,
        cost: 1.5,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 5000,
        moq: 10000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5000,
        totalInnerPacks: 2500,
        avgStoreUnits: 3.531073446327684,
        workbookNote: null,
      },
      {
        id: '5695:38',
        sourceRow: 38,
        sku: '10814875',
        description: 'ASH IRON RAVEN',
        type: 'Single SKU',
        vendor: 'SUNSTAR INDUSTRIES',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 3.05,
        cost: 19.94,
        retail: 79.99,
        childPurchaseUnits: null,
        purchaseQty: 2500,
        moq: 5000,
        pogSet: 1,
        pogMax: 3,
        totalQty: 2500,
        totalInnerPacks: 2500,
        avgStoreUnits: 1.765536723163842,
        workbookNote: null,
      },
      {
        id: '5695:39',
        sourceRow: 39,
        sku: '10814876',
        description: 'ASH CAST IRON LOCK & KEYS ',
        type: 'Single SKU',
        vendor: 'SUNSTAR INDUSTRIES',
        stores: 1416,
        cp: 12,
        ip: 2,
        cube: 0.418,
        cost: 3.77,
        retail: 24.99,
        childPurchaseUnits: null,
        purchaseQty: 3600,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '5695:40',
        sourceRow: 40,
        sku: '10815064',
        description: 'ASH WALL ENTER DARE SIGN',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 12,
        ip: 2,
        cube: 1.148,
        cost: 3.12,
        retail: 24.99,
        childPurchaseUnits: null,
        purchaseQty: 5208,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5208,
        totalInnerPacks: 2604,
        avgStoreUnits: 3.6779661016949152,
        workbookNote: null,
      },
      {
        id: '5695:41',
        sourceRow: 41,
        sku: '10815062',
        description: 'ASH TT RESIN DÉCOR OWL',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.968,
        cost: 5.45,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 3100,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3100,
        totalInnerPacks: 1550,
        avgStoreUnits: 2.189265536723164,
        workbookNote: null,
      },
      {
        id: '5695:42',
        sourceRow: 42,
        sku: '10815068',
        description: 'ASH FLORAL PREMADE',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.942,
        cost: 7.87,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 3800,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3800,
        totalInnerPacks: 1900,
        avgStoreUnits: 2.6836158192090394,
        workbookNote: null,
      },
      {
        id: '5695:43',
        sourceRow: 43,
        sku: '10815065',
        description: 'ASH RESIN SNAKE GLD',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.462,
        cost: 3.41,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 3600,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '5695:44',
        sourceRow: 44,
        sku: '10815067',
        description: 'ASH TT LITERALLLY DEAD',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 16,
        ip: 2,
        cube: 0.957,
        cost: 2.44,
        retail: 16.99,
        childPurchaseUnits: null,
        purchaseQty: 7200,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 7200,
        totalInnerPacks: 3600,
        avgStoreUnits: 5.084745762711864,
        workbookNote: null,
      },
      {
        id: '5695:45',
        sourceRow: 45,
        sku: '10815063',
        description: 'ASH SPIDER BOWL',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.246,
        cost: 12.45,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 2900,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 2900,
        totalInnerPacks: 1450,
        avgStoreUnits: 2.0480225988700567,
        workbookNote: null,
      },
      {
        id: '5695:46',
        sourceRow: 46,
        sku: '10815066',
        description: 'ASH TT DECOR TREE SM',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 3.343,
        cost: 5.84,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 4900,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4900,
        totalInnerPacks: 2450,
        avgStoreUnits: 3.4604519774011298,
        workbookNote: null,
      },
      {
        id: '5695:47',
        sourceRow: 47,
        sku: '10815071',
        description: 'ASH TT DECOR TREE LG',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 3.926,
        cost: 7.01,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 4900,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4900,
        totalInnerPacks: 2450,
        avgStoreUnits: 3.4604519774011298,
        workbookNote: null,
      },
      {
        id: '5695:48',
        sourceRow: 48,
        sku: '10815072',
        description: 'ASH TT DÉCOR BOOK',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 2.537,
        cost: 3.41,
        retail: 24.99,
        childPurchaseUnits: null,
        purchaseQty: 8208,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 8208,
        totalInnerPacks: 4104,
        avgStoreUnits: 5.796610169491525,
        workbookNote: null,
      },
      {
        id: '5695:49',
        sourceRow: 49,
        sku: '10815069',
        description: 'ASH TT POE PICTURE',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 12,
        ip: 2,
        cube: 1.337,
        cost: 3.41,
        retail: 22.99,
        childPurchaseUnits: null,
        purchaseQty: 5100,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5100,
        totalInnerPacks: 2550,
        avgStoreUnits: 3.6016949152542375,
        workbookNote: null,
      },
      {
        id: '5695:50',
        sourceRow: 50,
        sku: '10815070',
        description: 'ASH TT RESIN CROW BOOK',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.497,
        cost: 5.01,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 5100,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5100,
        totalInnerPacks: 2550,
        avgStoreUnits: 3.6016949152542375,
        workbookNote: null,
      },
      {
        id: '5695:51',
        sourceRow: 51,
        sku: '10815192',
        description: 'ASH TT RESIN CLOCK',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.369,
        cost: 4.24,
        retail: 24.99,
        childPurchaseUnits: null,
        purchaseQty: 3870,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3870,
        totalInnerPacks: 1935,
        avgStoreUnits: 2.733050847457627,
        workbookNote: null,
      },
      {
        id: '5695:52',
        sourceRow: 52,
        sku: '10814981',
        description: 'ASH TT HOURGLASS',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 12,
        ip: 2,
        cube: 1.616,
        cost: 4.24,
        retail: 22.99,
        childPurchaseUnits: null,
        purchaseQty: 6300,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 6300,
        totalInnerPacks: 3150,
        avgStoreUnits: 4.4491525423728815,
        workbookNote: null,
      },
      {
        id: '5695:53',
        sourceRow: 53,
        sku: '10814978',
        description: 'ASH TT DÉCOR BOOKS',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 12,
        ip: 2,
        cube: 2.265,
        cost: 3.46,
        retail: 22.99,
        childPurchaseUnits: null,
        purchaseQty: 6300,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 6300,
        totalInnerPacks: 3150,
        avgStoreUnits: 4.4491525423728815,
        workbookNote: null,
      },
      {
        id: '5695:54',
        sourceRow: 54,
        sku: '10815027',
        description: 'D-PIAB PUMPKIN S3',
        type: 'Parent',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 4.268,
        cost: 38.52,
        retail: 209.94,
        childPurchaseUnits: null,
        purchaseQty: 1575,
        moq: 5000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1575,
        totalInnerPacks: 1575,
        avgStoreUnits: 1.1122881355932204,
        workbookNote: null,
      },
      {
        id: '5695:55',
        sourceRow: 55,
        sku: '10815010',
        description: 'ASH TT BLK CMT PUMK TALL',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.977,
        cost: 6.03,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3150,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3150,
        totalInnerPacks: 1575,
        avgStoreUnits: 2.2245762711864407,
        workbookNote: null,
      },
      {
        id: '5695:56',
        sourceRow: 56,
        sku: '10815012',
        description: 'ASH TT BLK CMT PUMK LG',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.717,
        cost: 7.2,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 3150,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3150,
        totalInnerPacks: 1575,
        avgStoreUnits: 2.2245762711864407,
        workbookNote: null,
      },
      {
        id: '5695:57',
        sourceRow: 57,
        sku: '10815014',
        description: 'ASH TT BLK CMT PUMK SM',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.9,
        cost: 6.03,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 3150,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3150,
        totalInnerPacks: 1575,
        avgStoreUnits: 2.2245762711864407,
        workbookNote: null,
      },
      {
        id: '5695:58',
        sourceRow: 58,
        sku: '10815300',
        description: 'ASH MOON WREATH',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.124,
        cost: 9.54,
        retail: 59.99,
        childPurchaseUnits: null,
        purchaseQty: 3240,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3240,
        totalInnerPacks: 1620,
        avgStoreUnits: 2.288135593220339,
        workbookNote: null,
      },
      {
        id: '5695:59',
        sourceRow: 59,
        sku: '10815299',
        description: 'ASH WALL ARCH MIRROR SM',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.565,
        cost: 6.76,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 5500,
        moq: 5000,
        pogSet: 2,
        pogMax: 5,
        totalQty: 5500,
        totalInnerPacks: 2750,
        avgStoreUnits: 3.884180790960452,
        workbookNote: null,
      },
      {
        id: '5695:60',
        sourceRow: 60,
        sku: '10814999',
        description: 'ASH WALL ARCH MIRROR LG',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.983,
        cost: 9.39,
        retail: 69.99,
        childPurchaseUnits: null,
        purchaseQty: 3500,
        moq: 5000,
        pogSet: 2,
        pogMax: 3,
        totalQty: 3500,
        totalInnerPacks: 3500,
        avgStoreUnits: 2.4717514124293785,
        workbookNote: null,
      },
      {
        id: '5695:61',
        sourceRow: 61,
        sku: '10814990',
        description: 'ASH WALL ARCH DECOR',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 1.639,
        cost: 26.21,
        retail: 79.99,
        childPurchaseUnits: null,
        purchaseQty: 3500,
        moq: 5000,
        pogSet: 1,
        pogMax: 3,
        totalQty: 3500,
        totalInnerPacks: 3500,
        avgStoreUnits: 2.4717514124293785,
        workbookNote: null,
      },
      {
        id: '5695:62',
        sourceRow: 62,
        sku: '10815123',
        description: 'ASH TT MIRROR ',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.309,
        cost: 3.26,
        retail: 22.99,
        childPurchaseUnits: null,
        purchaseQty: 4140,
        moq: 5000,
        pogSet: 2,
        pogMax: 3,
        totalQty: 4140,
        totalInnerPacks: 2070,
        avgStoreUnits: 2.9237288135593222,
        workbookNote: null,
      },
      {
        id: '5695:63',
        sourceRow: 63,
        sku: '10815124',
        description: 'ASH PLW WILL TIL DEATH',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.781,
        cost: 4.53,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 5220,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5220,
        totalInnerPacks: 2610,
        avgStoreUnits: 3.6864406779661016,
        workbookNote: null,
      },
      {
        id: '5695:64',
        sourceRow: 64,
        sku: '10815128',
        description: 'ASH PLW COUPLE ',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.172,
        cost: 9.39,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 5580,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5580,
        totalInnerPacks: 2790,
        avgStoreUnits: 3.940677966101695,
        workbookNote: null,
      },
      {
        id: '5695:65',
        sourceRow: 65,
        sku: '10815122',
        description: 'ASH PLW LACE ',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.965,
        cost: 4.67,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 4950,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4950,
        totalInnerPacks: 2475,
        avgStoreUnits: 3.4957627118644066,
        workbookNote: null,
      },
      {
        id: '5695:66',
        sourceRow: 66,
        sku: '10814998',
        description: 'ASH TT METAL LANTEN LG',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.807,
        cost: 6.08,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3600,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '5695:67',
        sourceRow: 67,
        sku: '10814994',
        description: 'ASH TT METAL LANTEN SM',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.57,
        cost: 5.11,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 4320,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4320,
        totalInnerPacks: 2160,
        avgStoreUnits: 3.0508474576271185,
        workbookNote: null,
      },
      {
        id: '5695:68',
        sourceRow: 68,
        sku: '10815127',
        description: 'ASH PLW CROW ',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.286,
        cost: 7.44,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 5580,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5580,
        totalInnerPacks: 2790,
        avgStoreUnits: 3.940677966101695,
        workbookNote: null,
      },
      {
        id: '5695:69',
        sourceRow: 69,
        sku: '10815131',
        description: 'ASH PLW RAVEN',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.781,
        cost: 6.33,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 4950,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4950,
        totalInnerPacks: 2475,
        avgStoreUnits: 3.4957627118644066,
        workbookNote: null,
      },
      {
        id: '5695:70',
        sourceRow: 70,
        sku: '10815129',
        description: 'ASH PLW FLORAL ',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.846,
        cost: 4.33,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 4950,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4950,
        totalInnerPacks: 2475,
        avgStoreUnits: 3.4957627118644066,
        workbookNote: null,
      },
      {
        id: '5695:71',
        sourceRow: 71,
        sku: '10815130',
        description: 'ASH PREMADE PURPLE',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.157,
        cost: 2.63,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 4320,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4320,
        totalInnerPacks: 2160,
        avgStoreUnits: 3.0508474576271185,
        workbookNote: null,
      },
      {
        id: '5695:72',
        sourceRow: 72,
        sku: '10815125',
        description: 'ASH PREMADE GREEN',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.157,
        cost: 2.63,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 4320,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4320,
        totalInnerPacks: 2160,
        avgStoreUnits: 3.0508474576271185,
        workbookNote: null,
      },
      {
        id: '5695:73',
        sourceRow: 73,
        sku: '10815126',
        description: 'ASH PREMADE BLACK',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.157,
        cost: 2.63,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 4320,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4320,
        totalInnerPacks: 2160,
        avgStoreUnits: 3.0508474576271185,
        workbookNote: null,
      },
      {
        id: '5695:74',
        sourceRow: 74,
        sku: '10815155',
        description: 'D-PIAB BOX S2',
        type: 'Parent',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 1.029,
        cost: 16.64,
        retail: 109.96,
        childPurchaseUnits: null,
        purchaseQty: 1935,
        moq: 5000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1935,
        totalInnerPacks: 1935,
        avgStoreUnits: 1.3665254237288136,
        workbookNote: null,
      },
      {
        id: '5695:75',
        sourceRow: 75,
        sku: '10815134',
        description: 'ASH SKULL BOX LG',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.547,
        cost: 4.38,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 3870,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3870,
        totalInnerPacks: 1935,
        avgStoreUnits: 2.733050847457627,
        workbookNote: null,
      },
      {
        id: '5695:76',
        sourceRow: 76,
        sku: '10815135',
        description: 'ASH SKULL BOX SM',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.301,
        cost: 3.94,
        retail: 24.99,
        childPurchaseUnits: null,
        purchaseQty: 3870,
        moq: 5000,
        pogSet: 2,
        pogMax: 6,
        totalQty: 3870,
        totalInnerPacks: 1935,
        avgStoreUnits: 2.733050847457627,
        workbookNote: null,
      },
      {
        id: '5695:77',
        sourceRow: 77,
        sku: '10815156',
        description: 'D-PIAB TRAY S2',
        type: 'Parent',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 1.309,
        cost: 17.72,
        retail: 159.96,
        childPurchaseUnits: null,
        purchaseQty: 1710,
        moq: 5000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1710,
        totalInnerPacks: 1710,
        avgStoreUnits: 1.2076271186440677,
        workbookNote: null,
      },
      {
        id: '5695:78',
        sourceRow: 78,
        sku: '10815133',
        description: 'ASH TT RND TRAY BLK',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.752,
        cost: 5.11,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3420,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3420,
        totalInnerPacks: 1710,
        avgStoreUnits: 2.4152542372881354,
        workbookNote: null,
      },
      {
        id: '5695:79',
        sourceRow: 79,
        sku: '10815136',
        description: 'ASH TT RECT TRAY BLK',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.189,
        cost: 3.75,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3420,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3420,
        totalInnerPacks: 1710,
        avgStoreUnits: 2.4152542372881354,
        workbookNote: null,
      },
      {
        id: '5695:80',
        sourceRow: 80,
        sku: '10815132',
        description: 'ASH TT COCKTAIL TABLE',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 3.294,
        cost: 14.11,
        retail: 119.99,
        childPurchaseUnits: null,
        purchaseQty: 2800,
        moq: 5000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 2800,
        totalInnerPacks: 2800,
        avgStoreUnits: 1.9774011299435028,
        workbookNote: null,
      },
      {
        id: '5695:81',
        sourceRow: 81,
        sku: '10815137',
        description: 'ASH OVAL STOOL',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 2.54,
        cost: 17.66,
        retail: 119.99,
        childPurchaseUnits: null,
        purchaseQty: 2800,
        moq: 5000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 2800,
        totalInnerPacks: 2800,
        avgStoreUnits: 1.9774011299435028,
        workbookNote: null,
      },
      {
        id: '5695:82',
        sourceRow: 82,
        sku: '10815138',
        description: 'ASH WINE RACK SHELF',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 1.658,
        cost: 10.51,
        retail: 69.99,
        childPurchaseUnits: null,
        purchaseQty: 5200,
        moq: 5000,
        pogSet: 2,
        pogMax: 2,
        totalQty: 5200,
        totalInnerPacks: 5200,
        avgStoreUnits: 3.672316384180791,
        workbookNote: null,
      },
      {
        id: '5695:83',
        sourceRow: 83,
        sku: '10815143',
        description: 'ASH WALL CANVS SKEL  W/PIANO',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 12,
        ip: 2,
        cube: 2.836,
        cost: 4.62,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 6000,
        moq: 5000,
        pogSet: 2,
        pogMax: 2,
        totalQty: 6000,
        totalInnerPacks: 3000,
        avgStoreUnits: 4.237288135593221,
        workbookNote: null,
      },
      {
        id: '5695:84',
        sourceRow: 84,
        sku: '10815139',
        description: 'ASH TT ACRYLIC COASTER S4',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 0.448,
        cost: 4.04,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 4200,
        moq: 5000,
        pogSet: 2,
        pogMax: 6,
        totalQty: 4200,
        totalInnerPacks: 2100,
        avgStoreUnits: 2.9661016949152543,
        workbookNote: null,
      },
      {
        id: '5695:85',
        sourceRow: 85,
        sku: '10815141',
        description: 'ASH TT GLS PLATE',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 12,
        ip: 4,
        cube: 0.851,
        cost: 2.78,
        retail: 16.99,
        childPurchaseUnits: null,
        purchaseQty: 6000,
        moq: 5000,
        pogSet: 4,
        pogMax: 6,
        totalQty: 6000,
        totalInnerPacks: 1500,
        avgStoreUnits: 4.237288135593221,
        workbookNote: null,
      },
      {
        id: '5695:86',
        sourceRow: 86,
        sku: '10815140',
        description: 'ASH TT GLS DECANTER',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 12,
        ip: 2,
        cube: 2.647,
        cost: 7.78,
        retail: 49.99,
        childPurchaseUnits: null,
        purchaseQty: 3300,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3300,
        totalInnerPacks: 1650,
        avgStoreUnits: 2.330508474576271,
        workbookNote: null,
      },
      {
        id: '5695:87',
        sourceRow: 87,
        sku: '10815165',
        description: 'D-PIAB ASH GLASS S3',
        type: 'Parent',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.527,
        cost: 19.66,
        retail: 139.94,
        childPurchaseUnits: null,
        purchaseQty: 2250,
        moq: 5000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 2250,
        totalInnerPacks: 2250,
        avgStoreUnits: 1.5889830508474576,
        workbookNote: null,
      },
      {
        id: '5695:88',
        sourceRow: 88,
        sku: '10815142',
        description: 'ASH TT TALL GLASS BLK LG',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.188,
        cost: 3.07,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 4500,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4500,
        totalInnerPacks: 2250,
        avgStoreUnits: 3.1779661016949152,
        workbookNote: null,
      },
      {
        id: '5695:89',
        sourceRow: 89,
        sku: '10815144',
        description: 'ASH TT SHORT GLASS BLK SM',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.19,
        cost: 2.87,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 4500,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4500,
        totalInnerPacks: 2250,
        avgStoreUnits: 3.1779661016949152,
        workbookNote: null,
      },
      {
        id: '5695:90',
        sourceRow: 90,
        sku: '10815145',
        description: 'ASH TT WINE GLASS BLK',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.321,
        cost: 3.89,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 4500,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4500,
        totalInnerPacks: 2250,
        avgStoreUnits: 3.1779661016949152,
        workbookNote: null,
      },
      {
        id: '5695:91',
        sourceRow: 91,
        sku: '10815146',
        description: 'ASH TT GLS  SHOT GLASSES S6',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.303,
        cost: 11.48,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 3500,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3500,
        totalInnerPacks: 1750,
        avgStoreUnits: 2.4717514124293785,
        workbookNote: null,
      },
      {
        id: '5695:92',
        sourceRow: 92,
        sku: '10815148',
        description: 'ASH WALL HAUNTED HOUSE',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.034,
        cost: 9.92,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 4050,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4050,
        totalInnerPacks: 2025,
        avgStoreUnits: 2.860169491525424,
        workbookNote: null,
      },
      {
        id: '5695:93',
        sourceRow: 93,
        sku: '10815152',
        description: 'ASH WALL HAUNTED HSE SKELETON ',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.534,
        cost: 11.98,
        retail: 59.99,
        childPurchaseUnits: null,
        purchaseQty: 2880,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 2880,
        totalInnerPacks: 1440,
        avgStoreUnits: 2.0338983050847457,
        workbookNote: null,
      },
      {
        id: '5695:94',
        sourceRow: 94,
        sku: '10815151',
        description: 'ASH TT SNAKE DECOR SM',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.305,
        cost: 2.23,
        retail: 16.99,
        childPurchaseUnits: null,
        purchaseQty: 4050,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4050,
        totalInnerPacks: 2025,
        avgStoreUnits: 2.860169491525424,
        workbookNote: null,
      },
      {
        id: '5695:95',
        sourceRow: 95,
        sku: '10815150',
        description: 'ASH TT SNAKE DECOR LG',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.416,
        cost: 2.43,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '5695:96',
        sourceRow: 96,
        sku: '10815149',
        description: 'ASH TT STORYTELLER SIGN',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.214,
        cost: 2.44,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 6750,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 6750,
        totalInnerPacks: 3375,
        avgStoreUnits: 4.766949152542373,
        workbookNote: null,
      },
      {
        id: '5695:97',
        sourceRow: 97,
        sku: '10815147',
        description: 'ASH TT CLOCHE SPIDERBOOK',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 4,
        ip: 2,
        cube: 1.559,
        cost: 6.91,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '5695:98',
        sourceRow: 98,
        sku: '10815153',
        description: 'ASH TT RESIN TYPEWRITER RAVEN',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.438,
        cost: 2.83,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 3150,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3150,
        totalInnerPacks: 1575,
        avgStoreUnits: 2.2245762711864407,
        workbookNote: null,
      },
      {
        id: '5695:99',
        sourceRow: 99,
        sku: '10815154',
        description: 'ASH WALL STACKED BOOKS',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.362,
        cost: 4.71,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 5400,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5400,
        totalInnerPacks: 2700,
        avgStoreUnits: 3.8135593220338984,
        workbookNote: null,
      },
      {
        id: '5695:100',
        sourceRow: 100,
        sku: '10815157',
        description: 'ASH TT RESIN BK STND SET OF 2',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.681,
        cost: 7.82,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 4050,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4050,
        totalInnerPacks: 2025,
        avgStoreUnits: 2.860169491525424,
        workbookNote: null,
      },
      {
        id: '5695:101',
        sourceRow: 101,
        sku: '10815160',
        description: 'ASH TT CLOCHE INK MOTH',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 6,
        ip: 2,
        cube: 1.913,
        cost: 7.08,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 2970,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 2970,
        totalInnerPacks: 1485,
        avgStoreUnits: 2.097457627118644,
        workbookNote: null,
      },
      {
        id: '5695:102',
        sourceRow: 102,
        sku: '10815158',
        description: 'ASH WALL CERMC BOOK SIGN  A4',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 48,
        ip: 4,
        cube: 2.112,
        cost: 2.17,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 7056,
        moq: 2000,
        pogSet: 4,
        pogMax: 6,
        totalQty: 7056,
        totalInnerPacks: 1764,
        avgStoreUnits: 4.983050847457627,
        workbookNote: null,
      },
      {
        id: '5695:103',
        sourceRow: 103,
        sku: '10815162',
        description: 'ASH TT HAUNTED HOUSE SHELF',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.867,
        cost: 16.89,
        retail: 59.99,
        childPurchaseUnits: null,
        purchaseQty: 3150,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3150,
        totalInnerPacks: 1575,
        avgStoreUnits: 2.2245762711864407,
        workbookNote: null,
      },
      {
        id: '5695:104',
        sourceRow: 104,
        sku: '10815212',
        description: 'D-PIAB ASH TT BONE CNDLHDLR S3',
        type: 'Parent',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 2.734,
        cost: 24.7,
        retail: 153.94,
        childPurchaseUnits: null,
        purchaseQty: 1416,
        moq: 2000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1416,
        totalInnerPacks: 1416,
        avgStoreUnits: 1,
        workbookNote: null,
      },
      {
        id: '5695:105',
        sourceRow: 105,
        sku: '10815202',
        description: 'ASH TT BONE CNDLHDLR LG',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.91,
        cost: 5.06,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 2832,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 2832,
        totalInnerPacks: 1416,
        avgStoreUnits: 2,
        workbookNote: null,
      },
      {
        id: '5695:106',
        sourceRow: 106,
        sku: '10815205',
        description: 'ASH TT BONE CNDLHDLR MD',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.91,
        cost: 3.72,
        retail: 26.99,
        childPurchaseUnits: null,
        purchaseQty: 2832,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 2832,
        totalInnerPacks: 1416,
        avgStoreUnits: 2,
        workbookNote: null,
      },
      {
        id: '5695:107',
        sourceRow: 107,
        sku: '10815207',
        description: 'ASH TT BONE CNDLHDLR SM',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.91,
        cost: 3.57,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 2832,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 2832,
        totalInnerPacks: 1416,
        avgStoreUnits: 2,
        workbookNote: null,
      },
      {
        id: '5695:108',
        sourceRow: 108,
        sku: '10815164',
        description: 'ASH TT BOOK SHELF DÉCOR',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.395,
        cost: 16.73,
        retail: 59.99,
        childPurchaseUnits: null,
        purchaseQty: 2970,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 2970,
        totalInnerPacks: 1485,
        avgStoreUnits: 2.097457627118644,
        workbookNote: null,
      },
      {
        id: '5695:109',
        sourceRow: 109,
        sku: '10815163',
        description: 'ASH WALL DOORKNOB DÉCOR',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.684,
        cost: 7.17,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3150,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3150,
        totalInnerPacks: 1575,
        avgStoreUnits: 2.2245762711864407,
        workbookNote: null,
      },
      {
        id: '5695:110',
        sourceRow: 110,
        sku: '10815214',
        description: 'D-PIAB ASH WALL BANNER S4',
        type: 'Parent',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.915,
        cost: 50.96,
        retail: 279.92,
        childPurchaseUnits: null,
        purchaseQty: 2340,
        moq: 2000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 2340,
        totalInnerPacks: 2340,
        avgStoreUnits: 1.652542372881356,
        workbookNote: null,
      },
      {
        id: '5695:111',
        sourceRow: 111,
        sku: '10815201',
        description: 'ASH WALL BANNER MONKEY',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.228,
        cost: 6.37,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 4680,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4680,
        totalInnerPacks: 2340,
        avgStoreUnits: 3.305084745762712,
        workbookNote: null,
      },
      {
        id: '5695:112',
        sourceRow: 112,
        sku: '10815203',
        description: 'ASH WALL BANNER WOLF',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.228,
        cost: 6.37,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 4680,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4680,
        totalInnerPacks: 2340,
        avgStoreUnits: 3.305084745762712,
        workbookNote: null,
      },
      {
        id: '5695:113',
        sourceRow: 113,
        sku: '10815206',
        description: 'ASH WALL BANNER RAVEN',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.228,
        cost: 6.37,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 4680,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4680,
        totalInnerPacks: 2340,
        avgStoreUnits: 3.305084745762712,
        workbookNote: null,
      },
      {
        id: '5695:114',
        sourceRow: 114,
        sku: '10815209',
        description: 'ASH WALL BANNER DOG',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.228,
        cost: 6.37,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 4680,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4680,
        totalInnerPacks: 2340,
        avgStoreUnits: 3.305084745762712,
        workbookNote: null,
      },
      {
        id: '5695:115',
        sourceRow: 115,
        sku: '10815161',
        description: 'ASH TT RESIN SKELETON BUST',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 1.809,
        cost: 8.32,
        retail: 59.99,
        childPurchaseUnits: null,
        purchaseQty: 3150,
        moq: 2000,
        pogSet: 1,
        pogMax: 4,
        totalQty: 3150,
        totalInnerPacks: 3150,
        avgStoreUnits: 2.2245762711864407,
        workbookNote: null,
      },
      {
        id: '5695:116',
        sourceRow: 116,
        sku: '10815159',
        description: 'ASH WALL SKELETON W/ ABSINTHE',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.882,
        cost: 7.95,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 6500,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 6500,
        totalInnerPacks: 3250,
        avgStoreUnits: 4.590395480225989,
        workbookNote: null,
      },
      {
        id: '5695:117',
        sourceRow: 117,
        sku: '10815198',
        description: 'ASH WALL SPOOKEASY LOUNGE',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 6,
        ip: 2,
        cube: 1.743,
        cost: 8.1,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 5502,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5502,
        totalInnerPacks: 2751,
        avgStoreUnits: 3.885593220338983,
        workbookNote: null,
      },
      {
        id: '5695:118',
        sourceRow: 118,
        sku: '10815197',
        description: 'ASH WALL KEY W/ GRN TASSEL',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 1.756,
        cost: 2.32,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 6408,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 6408,
        totalInnerPacks: 3204,
        avgStoreUnits: 4.52542372881356,
        workbookNote: null,
      },
      {
        id: '5695:119',
        sourceRow: 119,
        sku: '10815213',
        description: 'D-PIAB ASH TT RESIN RAVEN S2',
        type: 'Parent',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 1.094,
        cost: 13.3,
        retail: 99.96,
        childPurchaseUnits: null,
        purchaseQty: 2750,
        moq: 2000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 2750,
        totalInnerPacks: 2750,
        avgStoreUnits: 1.942090395480226,
        workbookNote: null,
      },
      {
        id: '5695:120',
        sourceRow: 120,
        sku: '10815200',
        description: 'ASH TT RESIN RAVEN SQUARE',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.34,
        cost: 2.78,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 5500,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5500,
        totalInnerPacks: 2750,
        avgStoreUnits: 3.884180790960452,
        workbookNote: null,
      },
      {
        id: '5695:121',
        sourceRow: 121,
        sku: '10815204',
        description: 'ASH TT RESIN RAVEN ROUND',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.34,
        cost: 3.87,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 5500,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5500,
        totalInnerPacks: 2750,
        avgStoreUnits: 3.884180790960452,
        workbookNote: null,
      },
      {
        id: '5695:122',
        sourceRow: 122,
        sku: '10815195',
        description: 'ASH TT CANDELABRA GOLD',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.243,
        cost: 8.33,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 6500,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 6500,
        totalInnerPacks: 3250,
        avgStoreUnits: 4.590395480225989,
        workbookNote: null,
      },
      {
        id: '5695:123',
        sourceRow: 123,
        sku: '10815196',
        description: 'ASH WALL FRAME ABSINTHE',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 4,
        ip: 2,
        cube: 0.751,
        cost: 3.56,
        retail: 24.99,
        childPurchaseUnits: null,
        purchaseQty: 9000,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 9000,
        totalInnerPacks: 4500,
        avgStoreUnits: 6.3559322033898304,
        workbookNote: null,
      },
      {
        id: '5695:124',
        sourceRow: 124,
        sku: '10815211',
        description: 'D-PIAB ASH TT FRAME A2',
        type: 'Parent',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.298,
        cost: 21.04,
        retail: 91.96,
        childPurchaseUnits: null,
        purchaseQty: 2350,
        moq: 5000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 2350,
        totalInnerPacks: 2350,
        avgStoreUnits: 1.6596045197740112,
        workbookNote: null,
      },
      {
        id: '5695:125',
        sourceRow: 125,
        sku: '10815208',
        description: 'ASH TT FRAME SKULL',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.188,
        cost: 5.26,
        retail: 22.99,
        childPurchaseUnits: null,
        purchaseQty: 4700,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4700,
        totalInnerPacks: 2350,
        avgStoreUnits: 3.3192090395480225,
        workbookNote: null,
      },
      {
        id: '5695:126',
        sourceRow: 126,
        sku: '10815210',
        description: 'ASH TT FRAME TYPEWRITER',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.137,
        cost: 5.26,
        retail: 22.99,
        childPurchaseUnits: null,
        purchaseQty: 4700,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4700,
        totalInnerPacks: 2350,
        avgStoreUnits: 3.3192090395480225,
        workbookNote: null,
      },
    ],
  },
  {
    id: '8826',
    description: 'IRIDESCENT MOON (Touch of Twilight)',
    setDate: '2026-07-17',
    exitDate: '2026-09-25',
    pogDescription: 'Touch Of Twilight SC',
    location: 'SC - FMA 2',
    status: null,
    stores: 1416,
    dcCount: 7,
    sellableCount: 68,
    shippingCount: 58,
    piabCount: 7,
    cicoCount: 36,
    repackCount: 15,
    repackShipQty: 71354,
    lines: [
      {
        id: '8826:15',
        sourceRow: 15,
        sku: '10813618',
        description: 'ASH TT 16" IRON CAT',
        type: 'Single SKU',
        vendor: 'SUNSTAR INDUSTRIES',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 1.179,
        cost: 20.12,
        retail: 79.99,
        childPurchaseUnits: null,
        purchaseQty: 3026,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3026,
        totalInnerPacks: 3026,
        avgStoreUnits: 2.1370056497175143,
        workbookNote: null,
      },
      {
        id: '8826:16',
        sourceRow: 16,
        sku: '10813621',
        description: 'ASH TT CAT LAMP',
        type: 'Single SKU',
        vendor: 'TEST RITE WING ART LIGHTING AND GIFTWARE',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 1.1,
        cost: 9.9,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3560,
        moq: 5000,
        pogSet: 1,
        pogMax: 2,
        totalQty: 3560,
        totalInnerPacks: 3560,
        avgStoreUnits: 2.5141242937853105,
        workbookNote: null,
      },
      {
        id: '8826:17',
        sourceRow: 17,
        sku: '10814265',
        description: 'ASH BROOM DECOR',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 3.049,
        cost: 3.89,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 3560,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3560,
        totalInnerPacks: 1780,
        avgStoreUnits: 2.5141242937853105,
        workbookNote: null,
      },
      {
        id: '8826:18',
        sourceRow: 18,
        sku: '10813614',
        description: 'ASH WALL ART WITCH',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.694,
        cost: 5.06,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 9800,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 9800,
        totalInnerPacks: 4900,
        avgStoreUnits: 6.9209039548022595,
        workbookNote: null,
      },
      {
        id: '8826:19',
        sourceRow: 19,
        sku: '10813619',
        description: 'ASH TT WITCH DECOR',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 12,
        ip: 2,
        cube: 2.455,
        cost: 3.39,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 5796,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5796,
        totalInnerPacks: 2898,
        avgStoreUnits: 4.093220338983051,
        workbookNote: null,
      },
      {
        id: '8826:20',
        sourceRow: 20,
        sku: '10813633',
        description: 'ASH TT FROG DECOR',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.529,
        cost: 2.53,
        retail: 16.99,
        childPurchaseUnits: null,
        purchaseQty: 3116,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3116,
        totalInnerPacks: 1558,
        avgStoreUnits: 2.2005649717514126,
        workbookNote: null,
      },
      {
        id: '8826:21',
        sourceRow: 21,
        sku: '10813629',
        description: 'ASH WALL SIGN CAT',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 24,
        ip: 2,
        cube: 3.001,
        cost: 2.58,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 5880,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5880,
        totalInnerPacks: 2940,
        avgStoreUnits: 4.1525423728813555,
        workbookNote: null,
      },
      {
        id: '8826:22',
        sourceRow: 22,
        sku: '10813557',
        description: 'ASH WALL SIGN WITCH W/WAND LED',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.533,
        cost: 5.6,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 5880,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5880,
        totalInnerPacks: 2940,
        avgStoreUnits: 4.1525423728813555,
        workbookNote: null,
      },
      {
        id: '8826:23',
        sourceRow: 23,
        sku: '10813569',
        description: 'ASH WALL BLK CAT W LED',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.362,
        cost: 4.43,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 7120,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 7120,
        totalInnerPacks: 3560,
        avgStoreUnits: 5.028248587570621,
        workbookNote: null,
      },
      {
        id: '8826:24',
        sourceRow: 24,
        sku: '10813582',
        description: 'ASH WALL SPELLRM 24 HR SIGN',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 12,
        ip: 2,
        cube: 1.944,
        cost: 3.02,
        retail: 16.99,
        childPurchaseUnits: null,
        purchaseQty: 7572,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 7572,
        totalInnerPacks: 3786,
        avgStoreUnits: 5.3474576271186445,
        workbookNote: null,
      },
      {
        id: '8826:25',
        sourceRow: 25,
        sku: '10813584',
        description: 'ASH TT SKULL W/MUSHROOMS',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.712,
        cost: 7.08,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 3116,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3116,
        totalInnerPacks: 1558,
        avgStoreUnits: 2.2005649717514126,
        workbookNote: null,
      },
      {
        id: '8826:26',
        sourceRow: 26,
        sku: '10813577',
        description: 'ASH PLW WITCH HAT',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.781,
        cost: 4.38,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 3738,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3738,
        totalInnerPacks: 1869,
        avgStoreUnits: 2.639830508474576,
        workbookNote: null,
      },
      {
        id: '8826:27',
        sourceRow: 27,
        sku: '10813572',
        description: 'ASH TT DÉCOR SKULL ANIMAL HEAD',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.53,
        cost: 5.35,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3116,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3116,
        totalInnerPacks: 1558,
        avgStoreUnits: 2.2005649717514126,
        workbookNote: null,
      },
      {
        id: '8826:28',
        sourceRow: 28,
        sku: '10813700',
        description: 'D-PIAB ASH TT MUSHROOM S2',
        type: 'Parent',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.428,
        cost: 15.02,
        retail: 69.96,
        childPurchaseUnits: null,
        purchaseQty: 1914,
        moq: 5000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1914,
        totalInnerPacks: 1914,
        avgStoreUnits: 1.3516949152542372,
        workbookNote: null,
      },
      {
        id: '8826:29',
        sourceRow: 29,
        sku: '10813623',
        description: 'ASH TT MUSHROOM SM',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.085,
        cost: 3.32,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 3828,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3828,
        totalInnerPacks: 1914,
        avgStoreUnits: 2.7033898305084745,
        workbookNote: null,
      },
      {
        id: '8826:30',
        sourceRow: 30,
        sku: '10813626',
        description: 'ASH TT MUSHROOM LG',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.165,
        cost: 4.19,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 3828,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3828,
        totalInnerPacks: 1914,
        avgStoreUnits: 2.7033898305084745,
        workbookNote: null,
      },
      {
        id: '8826:31',
        sourceRow: 31,
        sku: '10813559',
        description: 'ASH WALL ART A4',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 4,
        ip: 4,
        cube: 0.495,
        cost: 4.38,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 6076,
        moq: 5000,
        pogSet: 4,
        pogMax: 6,
        totalQty: 6076,
        totalInnerPacks: 1519,
        avgStoreUnits: 4.290960451977401,
        workbookNote: null,
      },
      {
        id: '8826:32',
        sourceRow: 32,
        sku: '10813461',
        description: 'D-PIAB TT DÉCOR BUD S3',
        type: 'Parent',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 2.147,
        cost: 20.04,
        retail: 119.94,
        childPurchaseUnits: null,
        purchaseQty: 1780,
        moq: 5000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1780,
        totalInnerPacks: 1780,
        avgStoreUnits: 1.2570621468926553,
        workbookNote: null,
      },
      {
        id: '8826:33',
        sourceRow: 33,
        sku: '10813409',
        description: 'ASH TT DÉCOR SPECIMEN BUG A',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.385,
        cost: 3.34,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 3560,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3560,
        totalInnerPacks: 1780,
        avgStoreUnits: 2.5141242937853105,
        workbookNote: null,
      },
      {
        id: '8826:34',
        sourceRow: 34,
        sku: '10813412',
        description: 'ASH TT DÉCOR SPECIMEN BUG B',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.356,
        cost: 3.34,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 3560,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3560,
        totalInnerPacks: 1780,
        avgStoreUnits: 2.5141242937853105,
        workbookNote: null,
      },
      {
        id: '8826:35',
        sourceRow: 35,
        sku: '10813415',
        description: 'ASH TT DÉCOR SPECIMEN BUG C',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.439,
        cost: 3.34,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 3560,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3560,
        totalInnerPacks: 1780,
        avgStoreUnits: 2.5141242937853105,
        workbookNote: null,
      },
      {
        id: '8826:36',
        sourceRow: 36,
        sku: '10813376',
        description: 'ASH WALL THREE BROOM SIGN',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.313,
        cost: 3.51,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 6860,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 6860,
        totalInnerPacks: 3430,
        avgStoreUnits: 4.844632768361582,
        workbookNote: null,
      },
      {
        id: '8826:37',
        sourceRow: 37,
        sku: '10813397',
        description: 'ASH WALL BROOM W/HAT SIGN',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.333,
        cost: 3.51,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 6860,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 6860,
        totalInnerPacks: 3430,
        avgStoreUnits: 4.844632768361582,
        workbookNote: null,
      },
      {
        id: '8826:38',
        sourceRow: 38,
        sku: '10813377',
        description: 'ASH WALL SIGN CAULDRON',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.333,
        cost: 3.51,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 6860,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 6860,
        totalInnerPacks: 3430,
        avgStoreUnits: 4.844632768361582,
        workbookNote: null,
      },
      {
        id: '8826:39',
        sourceRow: 39,
        sku: '10813398',
        description: 'ASH WALL SIGN BROOM',
        type: 'Single SKU',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.333,
        cost: 3.51,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 6860,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 6860,
        totalInnerPacks: 3430,
        avgStoreUnits: 4.844632768361582,
        workbookNote: null,
      },
      {
        id: '8826:40',
        sourceRow: 40,
        sku: '10813392',
        description: 'D-PIAB GLS POTION BTL S2',
        type: 'Parent',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.317,
        cost: 10.92,
        retail: 59.96,
        childPurchaseUnits: null,
        purchaseQty: 2314,
        moq: 5000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 2314,
        totalInnerPacks: 2314,
        avgStoreUnits: 1.634180790960452,
        workbookNote: null,
      },
      {
        id: '8826:41',
        sourceRow: 41,
        sku: '10813370',
        description: 'ASH TT GLS POTION BTL BROWN',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.206,
        cost: 2.73,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 4628,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4628,
        totalInnerPacks: 2314,
        avgStoreUnits: 3.268361581920904,
        workbookNote: null,
      },
      {
        id: '8826:42',
        sourceRow: 42,
        sku: '10813371',
        description: 'ASH TT GLS POTION BTL BLU',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.206,
        cost: 2.73,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 4628,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4628,
        totalInnerPacks: 2314,
        avgStoreUnits: 3.268361581920904,
        workbookNote: null,
      },
      {
        id: '8826:43',
        sourceRow: 43,
        sku: '10813424',
        description: 'D-PIAB GLS BOTTLE S3',
        type: 'Parent',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.647,
        cost: 9.26,
        retail: 83.94,
        childPurchaseUnits: null,
        purchaseQty: 2448,
        moq: 5000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 2448,
        totalInnerPacks: 2448,
        avgStoreUnits: 1.728813559322034,
        workbookNote: null,
      },
      {
        id: '8826:44',
        sourceRow: 44,
        sku: '10813388',
        description: 'ASH GLS BOTTLE AMBER LG',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.29,
        cost: 1.95,
        retail: 16.99,
        childPurchaseUnits: null,
        purchaseQty: 4896,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4896,
        totalInnerPacks: 2448,
        avgStoreUnits: 3.457627118644068,
        workbookNote: null,
      },
      {
        id: '8826:45',
        sourceRow: 45,
        sku: '10813391',
        description: 'ASH GLS BOTTLE AMBER MD',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.102,
        cost: 1.46,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 4896,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4896,
        totalInnerPacks: 2448,
        avgStoreUnits: 3.457627118644068,
        workbookNote: null,
      },
      {
        id: '8826:46',
        sourceRow: 46,
        sku: '10813395',
        description: 'ASH GLS BOTTLE AMBER SM',
        type: 'Child',
        vendor: 'IN THE FLOW DESIGN LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.063,
        cost: 1.22,
        retail: 9.99,
        childPurchaseUnits: null,
        purchaseQty: 4896,
        moq: 5000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4896,
        totalInnerPacks: 2448,
        avgStoreUnits: 3.457627118644068,
        workbookNote: null,
      },
      {
        id: '8826:47',
        sourceRow: 47,
        sku: '10813562',
        description: 'ASH WALL TWIG MIRROR',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 1.449,
        cost: 14.4,
        retail: 59.99,
        childPurchaseUnits: null,
        purchaseQty: 3738,
        moq: 2000,
        pogSet: 1,
        pogMax: 3,
        totalQty: 3738,
        totalInnerPacks: 3738,
        avgStoreUnits: 2.639830508474576,
        workbookNote: null,
      },
      {
        id: '8826:48',
        sourceRow: 48,
        sku: '10813390',
        description: 'ASH TT RESIN RATTAN BLK CAT',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.035,
        cost: 6.76,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 3738,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3738,
        totalInnerPacks: 1869,
        avgStoreUnits: 2.639830508474576,
        workbookNote: null,
      },
      {
        id: '8826:49',
        sourceRow: 49,
        sku: '10813366',
        description: 'ASH TT RESIN RATTAN BOOTS',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.142,
        cost: 7.36,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 3738,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3738,
        totalInnerPacks: 1869,
        avgStoreUnits: 2.639830508474576,
        workbookNote: null,
      },
      {
        id: '8826:50',
        sourceRow: 50,
        sku: '10813368',
        description: 'ASH TT RESIN RATTAN HAT',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.963,
        cost: 7.79,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 3738,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3738,
        totalInnerPacks: 1869,
        avgStoreUnits: 2.639830508474576,
        workbookNote: null,
      },
      {
        id: '8826:51',
        sourceRow: 51,
        sku: '10813475',
        description: 'D-PIAB ASH TT TLIGHT HDLR S3',
        type: 'Parent',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 2.956,
        cost: 42.76,
        retail: 239.94,
        childPurchaseUnits: null,
        purchaseQty: 1558,
        moq: 2000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1558,
        totalInnerPacks: 1558,
        avgStoreUnits: 1.1002824858757063,
        workbookNote: null,
      },
      {
        id: '8826:52',
        sourceRow: 52,
        sku: '10813435',
        description: 'ASH TT GLD TLIGHT HDLR 1',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.984,
        cost: 7.08,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3116,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3116,
        totalInnerPacks: 1558,
        avgStoreUnits: 2.2005649717514126,
        workbookNote: null,
      },
      {
        id: '8826:53',
        sourceRow: 53,
        sku: '10813437',
        description: 'ASH TT GLD TLIGHT HDLR 2',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.984,
        cost: 7.46,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3116,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3116,
        totalInnerPacks: 1558,
        avgStoreUnits: 2.2005649717514126,
        workbookNote: null,
      },
      {
        id: '8826:54',
        sourceRow: 54,
        sku: '10813440',
        description: 'ASH TT GLD TLIGHT HDLR 3',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.984,
        cost: 6.84,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3116,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3116,
        totalInnerPacks: 1558,
        avgStoreUnits: 2.2005649717514126,
        workbookNote: null,
      },
      {
        id: '8826:55',
        sourceRow: 55,
        sku: '10813551',
        description: 'ASH TT PHONE CLOCK DECOR',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 8,
        ip: 2,
        cube: 2.005,
        cost: 5.89,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 3560,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3560,
        totalInnerPacks: 1780,
        avgStoreUnits: 2.5141242937853105,
        workbookNote: null,
      },
      {
        id: '8826:56',
        sourceRow: 56,
        sku: '10813542',
        description: 'ASH TT CLOCHE KEY ',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.644,
        cost: 5.72,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3560,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3560,
        totalInnerPacks: 1780,
        avgStoreUnits: 2.5141242937853105,
        workbookNote: null,
      },
      {
        id: '8826:57',
        sourceRow: 57,
        sku: '10813528',
        description: 'ASH TT RESIN RATTAN PMKIN SM',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.084,
        cost: 5.99,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 3828,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3828,
        totalInnerPacks: 1914,
        avgStoreUnits: 2.7033898305084745,
        workbookNote: null,
      },
      {
        id: '8826:58',
        sourceRow: 58,
        sku: '10813523',
        description: 'ASH TT RESIN RATTAN PMKIN LG',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.258,
        cost: 6.69,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 3738,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3738,
        totalInnerPacks: 1869,
        avgStoreUnits: 2.639830508474576,
        workbookNote: null,
      },
      {
        id: '8826:59',
        sourceRow: 59,
        sku: '10813531',
        description: 'ASH TT CABINET BAT SKULL ',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.312,
        cost: 17.23,
        retail: 59.99,
        childPurchaseUnits: null,
        purchaseQty: 2848,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 2848,
        totalInnerPacks: 1424,
        avgStoreUnits: 2.0112994350282487,
        workbookNote: null,
      },
      {
        id: '8826:60',
        sourceRow: 60,
        sku: '10813529',
        description: 'ASH TT CLOCHE BUTTERFLY',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 4,
        ip: 2,
        cube: 1.806,
        cost: 8.33,
        retail: 39.99,
        childPurchaseUnits: null,
        purchaseQty: 3384,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3384,
        totalInnerPacks: 1692,
        avgStoreUnits: 2.389830508474576,
        workbookNote: null,
      },
      {
        id: '8826:61',
        sourceRow: 61,
        sku: '10813527',
        description: 'ASH TT BLOCK BLK CAT',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 8,
        ip: 2,
        cube: 0.786,
        cost: 3.89,
        retail: 16.99,
        childPurchaseUnits: null,
        purchaseQty: 5168,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5168,
        totalInnerPacks: 2584,
        avgStoreUnits: 3.6497175141242937,
        workbookNote: null,
      },
      {
        id: '8826:62',
        sourceRow: 62,
        sku: '10813512',
        description: 'ASH WALL WITCH A2',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 8,
        ip: 2,
        cube: 1.24,
        cost: 3.6,
        retail: 26.99,
        childPurchaseUnits: null,
        purchaseQty: 5792,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5792,
        totalInnerPacks: 2896,
        avgStoreUnits: 4.090395480225989,
        workbookNote: null,
      },
      {
        id: '8826:63',
        sourceRow: 63,
        sku: '10813507',
        description: 'ASH TT WITCH HAND',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.433,
        cost: 4.05,
        retail: 24.99,
        childPurchaseUnits: null,
        purchaseQty: 4006,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4006,
        totalInnerPacks: 2003,
        avgStoreUnits: 2.82909604519774,
        workbookNote: null,
      },
      {
        id: '8826:64',
        sourceRow: 64,
        sku: '10813533',
        description: 'ASH TT WITCHES BREW RECIPES',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 12,
        ip: 2,
        cube: 1.368,
        cost: 4.17,
        retail: 16.99,
        childPurchaseUnits: null,
        purchaseQty: 6684,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 6684,
        totalInnerPacks: 3342,
        avgStoreUnits: 4.720338983050848,
        workbookNote: null,
      },
      {
        id: '8826:65',
        sourceRow: 65,
        sku: '10813439',
        description: 'D-PIAB ASH TT BOOK DÉCOR S3',
        type: 'Parent',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.418,
        cost: 19.42,
        retail: 89.94,
        childPurchaseUnits: null,
        purchaseQty: 2759,
        moq: 2000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 2759,
        totalInnerPacks: 2759,
        avgStoreUnits: 1.948446327683616,
        workbookNote: null,
      },
      {
        id: '8826:66',
        sourceRow: 66,
        sku: '10813408',
        description: "ASH TT BOOK WITCH'S LAIR SM",
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.139,
        cost: 2.29,
        retail: 9.99,
        childPurchaseUnits: null,
        purchaseQty: 5518,
        moq: 2000,
        pogSet: 2,
        pogMax: 6,
        totalQty: 5518,
        totalInnerPacks: 2759,
        avgStoreUnits: 3.896892655367232,
        workbookNote: null,
      },
      {
        id: '8826:67',
        sourceRow: 67,
        sku: '10813411',
        description: 'ASH TT BOOK OF SPELLS MD',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.139,
        cost: 3.12,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 5518,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5518,
        totalInnerPacks: 2759,
        avgStoreUnits: 3.896892655367232,
        workbookNote: null,
      },
      {
        id: '8826:68',
        sourceRow: 68,
        sku: '10813414',
        description: 'ASH TT BOOK POTIONS LG',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.139,
        cost: 4.3,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 5518,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5518,
        totalInnerPacks: 2759,
        avgStoreUnits: 3.896892655367232,
        workbookNote: null,
      },
      {
        id: '8826:69',
        sourceRow: 69,
        sku: '10813522',
        description: 'ASH TT RESIN EGG TOPIARY SM',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.24,
        cost: 3.78,
        retail: 14.99,
        childPurchaseUnits: null,
        purchaseQty: 3560,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3560,
        totalInnerPacks: 1780,
        avgStoreUnits: 2.5141242937853105,
        workbookNote: null,
      },
      {
        id: '8826:70',
        sourceRow: 70,
        sku: '10813509',
        description: 'ASH TT RESIN EGG TOPIARY LG',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.38,
        cost: 4.17,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 3116,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3116,
        totalInnerPacks: 1558,
        avgStoreUnits: 2.2005649717514126,
        workbookNote: null,
      },
      {
        id: '8826:71',
        sourceRow: 71,
        sku: '10813526',
        description: 'ASH PLW BLK CAT BOOK SHELF',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.621,
        cost: 4.64,
        retail: 34.99,
        childPurchaseUnits: null,
        purchaseQty: 4450,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4450,
        totalInnerPacks: 2225,
        avgStoreUnits: 3.1426553672316384,
        workbookNote: null,
      },
      {
        id: '8826:72',
        sourceRow: 72,
        sku: '10813417',
        description: 'ASH TT RAVEN MOON CNDL HDLR',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 8,
        ip: 2,
        cube: 1.673,
        cost: 4.2,
        retail: 16.99,
        childPurchaseUnits: null,
        purchaseQty: 4808,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4808,
        totalInnerPacks: 2404,
        avgStoreUnits: 3.3954802259887007,
        workbookNote: null,
      },
      {
        id: '8826:73',
        sourceRow: 73,
        sku: '10813524',
        description: 'ASH TT BAT MOON CNDL HDLR',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 8,
        ip: 2,
        cube: 1.98,
        cost: 4.46,
        retail: 16.99,
        childPurchaseUnits: null,
        purchaseQty: 4808,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4808,
        totalInnerPacks: 2404,
        avgStoreUnits: 3.3954802259887007,
        workbookNote: null,
      },
      {
        id: '8826:74',
        sourceRow: 74,
        sku: '10813536',
        description: 'ASH TT BLK CAT CNDL HDLR',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 8,
        ip: 2,
        cube: 2.102,
        cost: 5.16,
        retail: 16.99,
        childPurchaseUnits: null,
        purchaseQty: 4808,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4808,
        totalInnerPacks: 2404,
        avgStoreUnits: 3.3954802259887007,
        workbookNote: null,
      },
      {
        id: '8826:75',
        sourceRow: 75,
        sku: '10813515',
        description: 'ASH TT RESIN RAVEN BLK CAT',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.803,
        cost: 3.86,
        retail: 24.99,
        childPurchaseUnits: null,
        purchaseQty: 5696,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 5696,
        totalInnerPacks: 2848,
        avgStoreUnits: 4.022598870056497,
        workbookNote: null,
      },
      {
        id: '8826:76',
        sourceRow: 76,
        sku: '10813289',
        description: 'ASH TT CAULDRON SHELF',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.644,
        cost: 11.05,
        retail: 44.99,
        childPurchaseUnits: null,
        purchaseQty: 3738,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3738,
        totalInnerPacks: 1869,
        avgStoreUnits: 2.639830508474576,
        workbookNote: null,
      },
      {
        id: '8826:77',
        sourceRow: 77,
        sku: '10813238',
        description: 'ASH WALL WITCH MUST HAVE',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 4,
        ip: 2,
        cube: 1.196,
        cost: 7.23,
        retail: 49.99,
        childPurchaseUnits: null,
        purchaseQty: 3116,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3116,
        totalInnerPacks: 1558,
        avgStoreUnits: 2.2005649717514126,
        workbookNote: null,
      },
      {
        id: '8826:78',
        sourceRow: 78,
        sku: '10813263',
        description: 'ASH WALL CLOCK THE OLD SALEM',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 6,
        ip: 2,
        cube: 1.946,
        cost: 7.33,
        retail: 49.99,
        childPurchaseUnits: null,
        purchaseQty: 2850,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 2850,
        totalInnerPacks: 1425,
        avgStoreUnits: 2.01271186440678,
        workbookNote: null,
      },
      {
        id: '8826:79',
        sourceRow: 79,
        sku: '10813270',
        description: 'ASH TT CURIOSITY BOX SKULL',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.611,
        cost: 12.29,
        retail: 59.99,
        childPurchaseUnits: null,
        purchaseQty: 2848,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 2848,
        totalInnerPacks: 1424,
        avgStoreUnits: 2.0112994350282487,
        workbookNote: null,
      },
      {
        id: '8826:80',
        sourceRow: 80,
        sku: '10813272',
        description: 'ASH TT RESIN CAULDRON',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 1.771,
        cost: 4.48,
        retail: 29.99,
        childPurchaseUnits: null,
        purchaseQty: 3116,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3116,
        totalInnerPacks: 1558,
        avgStoreUnits: 2.2005649717514126,
        workbookNote: null,
      },
      {
        id: '8826:81',
        sourceRow: 81,
        sku: '10813996',
        description: 'ASH TT TEST TUBE',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 36,
        ip: 2,
        cube: 5.999,
        cost: 4.08,
        retail: 24.99,
        childPurchaseUnits: null,
        purchaseQty: 3564,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3564,
        totalInnerPacks: 1782,
        avgStoreUnits: 2.516949152542373,
        workbookNote: null,
      },
      {
        id: '8826:82',
        sourceRow: 82,
        sku: '10814058',
        description: 'D-PIAB ASH TT CAULDRON S3',
        type: 'Parent',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 0.771,
        cost: 16.06,
        retail: 103.94,
        childPurchaseUnits: null,
        purchaseQty: 1800,
        moq: 2000,
        pogSet: 1,
        pogMax: 1,
        totalQty: 1800,
        totalInnerPacks: 1800,
        avgStoreUnits: 1.271186440677966,
        workbookNote: null,
      },
      {
        id: '8826:83',
        sourceRow: 83,
        sku: '10814007',
        description: 'ASH TT CAULDRON POSION',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.173,
        cost: 2.27,
        retail: 14.99,
        childPurchaseUnits: 1740,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '8826:84',
        sourceRow: 84,
        sku: '10814011',
        description: 'ASH TT CAULDRON BREW',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.242,
        cost: 2.74,
        retail: 16.99,
        childPurchaseUnits: 672,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '8826:85',
        sourceRow: 85,
        sku: '10814013',
        description: 'ASH TT CAULDRON LOVE POTION',
        type: 'Child',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.254,
        cost: 3.02,
        retail: 19.99,
        childPurchaseUnits: 0,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3600,
        totalInnerPacks: 1800,
        avgStoreUnits: 2.542372881355932,
        workbookNote: null,
      },
      {
        id: '8826:86',
        sourceRow: 86,
        sku: '10813287',
        description: 'ASH TT WICKED CUTOUT',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 12,
        ip: 2,
        cube: 0.846,
        cost: 2.81,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 3564,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3564,
        totalInnerPacks: 1782,
        avgStoreUnits: 2.516949152542373,
        workbookNote: null,
      },
      {
        id: '8826:87',
        sourceRow: 87,
        sku: '10813284',
        description: 'ASH TT RESIN SNAIL DÉCOR',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.35,
        cost: 3.59,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 3916,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 3916,
        totalInnerPacks: 1958,
        avgStoreUnits: 2.7655367231638417,
        workbookNote: null,
      },
      {
        id: '8826:88',
        sourceRow: 88,
        sku: '10813280',
        description: 'ASH TT CER BOOK CTNR',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.525,
        cost: 4.67,
        retail: 19.99,
        childPurchaseUnits: null,
        purchaseQty: 4896,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 4896,
        totalInnerPacks: 2448,
        avgStoreUnits: 3.457627118644068,
        workbookNote: null,
      },
      {
        id: '8826:89',
        sourceRow: 89,
        sku: '10813282',
        description: 'ASH TT BIRD CAGE DÉCOR',
        type: 'Single SKU',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 1,
        ip: 1,
        cube: 2.315,
        cost: 19.58,
        retail: 99.99,
        childPurchaseUnits: null,
        purchaseQty: 2492,
        moq: 2000,
        pogSet: 1,
        pogMax: 2,
        totalQty: 2492,
        totalInnerPacks: 2492,
        avgStoreUnits: 1.7598870056497176,
        workbookNote: null,
      },
      {
        id: '8826:91',
        sourceRow: 91,
        sku: '10814007',
        description: 'ASH TT CAULDRON POSION',
        type: 'Replen',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.173,
        cost: 2.27,
        retail: 14.99,
        childPurchaseUnits: 1740,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 1740,
        totalInnerPacks: 870,
        avgStoreUnits: 1.228813559322034,
        workbookNote: null,
      },
      {
        id: '8826:92',
        sourceRow: 92,
        sku: '10814011',
        description: 'ASH TT CAULDRON BREW',
        type: 'Replen',
        vendor: 'BEAU MONDE HONG KONG COMPANY LIMITED',
        stores: 1416,
        cp: 2,
        ip: 2,
        cube: 0.242,
        cost: 2.74,
        retail: 16.99,
        childPurchaseUnits: 672,
        purchaseQty: 3600,
        moq: 2000,
        pogSet: 2,
        pogMax: 4,
        totalQty: 672,
        totalInnerPacks: 336,
        avgStoreUnits: 0.4745762711864407,
        workbookNote: null,
      },
    ],
  },
]

// Planning demo assumption requested by the user; keep source workbook values above.
// Both SKU detail and DC planning use the same fixed MOQ.
export const DEMO_SKU_MOQ = 3000
export const SKU_WAVE_FIXTURES: SkuWaveFixture[] =
  WORKBOOK_SKU_WAVE_FIXTURES.map(fixture => ({
    ...fixture,
    lines: fixture.lines.map(line => ({ ...line, moq: DEMO_SKU_MOQ })),
  }))
